// 全局价格定义，统一在此处维护，方便后期调整
const VOTE_PRICE_ETH = 0.01
const MINT_PRICE_ETH = 0.03

function calcPrice(price, platform) {
    console.log('calcPrice', price, platform)
    if (!platform) {
        platform = 'ETH'
    }
    if (platform === 'CFX') {
        // CFX 使用历史比例换算（保持与之前 0.05 -> 0.005 一致的 1/10 关系）
        if (price == VOTE_PRICE_ETH) {
            price = VOTE_PRICE_ETH / 10
        }
        return Math.round(price * sessionStorage.getItem('cfxRate') * 100) / 100
    } else {
        return price
    }
}

function getChainProperty(data) {
    let platform = data.shortName
    if (!platform) {
        platform = 'ETH'
    }

    if (platform === 'ETH') {
        data['vote_price'] = VOTE_PRICE_ETH
        data['mint_price'] = MINT_PRICE_ETH
        data['local_icon'] = 'nft.svg'
    } else if (platform === 'CFX') {
        data['vote_price'] = Math.round(VOTE_PRICE_ETH * sessionStorage.getItem('cfxRate') * 100) / 100
        data['mint_price'] = Math.round(MINT_PRICE_ETH * sessionStorage.getItem('cfxRate') * 100) / 100
        data['local_icon'] = 'conflux_logo_only.png'
    } else if (platform === 'BTY') {
        data['vote_price'] = Math.round(VOTE_PRICE_ETH * sessionStorage.getItem('btyRate') * 100) / 100
        data['mint_price'] = Math.round(MINT_PRICE_ETH * sessionStorage.getItem('btyRate') * 100) / 100
        data['local_icon'] = 'BTY-logo.png'
    }
    console.log('getChainProperty', data)

    return data
}

module.exports = {calcPrice, getChainProperty, VOTE_PRICE_ETH, MINT_PRICE_ETH};
